import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperNumbers from "../../../helpers/numbers";
import allTransactionScoreToWalletAdvertiser from "./AllTransactionScoreToWallet";

export default function AllTransactionScoreToWalletAdvertiser() {
  const generateAllTransactionScoreToWalletAdvertiser = () => {
    return (
      <>
        <div className="pb-4 px-2">
          <div>
            <Link
              to="/finance/add-transaction-score-to-wallet-advertiser"
              className="btn btn-success"
            >
              <span className="pl-2">
                <i className="fa fa-plus"> </i>
              </span>
              <span>درخواست تبدیل امتیاز به شارژ تبلیغ دهنده</span>
            </Link>
          </div>
          <div className="table-responsive pt-2">
            <table className="table table-hilite tbl-td-white-space">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره تبدیل</td>
                  <td>امتیاز</td>
                  <td>شارژ تبلیغ دهنده (تومان)</td>
                  <td>تاربخ درج</td>
                </tr>
              </thead>
              <tbody>
                {allTransactionScoreToWalletAdvertiser.map((item, index) => {
                  return (
                    <tr>
                      <td>{helperNumbers.toPersianNum(index + 1)}</td>
                      <td>{helperNumbers.toPersianNum(item.id)}</td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(item.score)
                        )}
                      </td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(item.wallet)
                        )}
                      </td>

                      <td>{item.created_at}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar
        openItem="finance"
        activeItem="all-transaction-score-to-wallet-advertiser"
      />

      <div className="content-wrapper">
        <TitleBar
          title="تبدیل امتیاز به شارژ تبلیغ دهنده
"
        />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {generateAllTransactionScoreToWalletAdvertiser()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
